import React from "react";
import styled from "styled-components";

import PropTypes from "prop-types";

import { transition } from "../../../styles/variables";
import WineRating from "../WineRating";

import starFill from "../../../assets/images/icons/start-fill.svg";
import starEmpty from "../../../assets/images/icons/star-empty.svg";

const FeedbackRatingItem = styled.span`
  display: inline-block;
  margin: 0px 2px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  cursor: pointer;
  transition: ${transition.baseTransition};
`;

const FeedbackRatingItemFill = styled(FeedbackRatingItem)`
  background-image: url("${starFill}");
  width: ${(props) => (props.largeIcon ? "40px" : "15px")};
  height: ${(props) => (props.largeIcon ? "40px" : "15px")};
`;
FeedbackRatingItemFill.propTypes = {
  largeIcon: PropTypes.bool.isRequired,
};

const FeedbackRatingItemEmpty = styled(FeedbackRatingItem)`
  background-image: url("${starEmpty}");
  width: ${(props) => (props.largeIcon ? "40px" : "15px")};
  height: ${(props) => (props.largeIcon ? "40px" : "15px")};
`;
FeedbackRatingItemEmpty.propTypes = {
  largeIcon: PropTypes.bool.isRequired,
};

const FeedbackRatingItemToggle = ({ isFilled, onClick, largeIcon }) =>
  isFilled ? (
    <FeedbackRatingItemFill onClick={onClick} largeIcon={largeIcon} />
  ) : (
    <FeedbackRatingItemEmpty onClick={onClick} largeIcon={largeIcon} />
  );

FeedbackRatingItemToggle.propTypes = {
  isFilled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  largeIcon: PropTypes.bool.isRequired,
};

const FeedbackRatingList = styled(WineRating)`
  text-align: ${(props) => props.textAlign};
  display: flex;
  align-items: ${(props) => props.textAlign};
  justify-content: ${(props) => props.textAlign};
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const WineCardCellarRating = ({
  textAlign = "center",
  rating,
  largeIcon = false,
  onClickRating = (_rating) => {},
  mediumIcon = false,
  pending = false,
}) => (
  <FeedbackRatingList
    textAlign={textAlign}
    rating={rating}
    largeIcon={largeIcon}
    onClickRating={onClickRating}
    mediumIcon={mediumIcon}
    pending={pending}
  />
);

WineCardCellarRating.propTypes = {
  largeIcon: PropTypes.bool,
  mediumIcon: PropTypes.bool,
  textAlign: PropTypes.string,
  rating: PropTypes.number,
  onClickRating: PropTypes.func,
  pending: PropTypes.bool,
};

export default WineCardCellarRating;
